module.exports = fox._r("images/empty-page-bg.jpg", __webpack_public_path__ + "_/_/_/common/frame/images/empty-page-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-page-bg.jpg
// module id = 88
// module chunks = 2